<template>
	<div class="product flex-center">
		<c-file media :src="image" style="width:46px; height:46px"></c-file>
		<p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{name}}</p>
	</div>
</template>

<script>
	export default {
		props: {
			image: String,
			
			imageSize: {
				type: [Number, String],
				default: 46
			},
			
			name: String
		}
	}
</script>

<style lang="stylus" scoped>
</style>
